import { ParentProps, Signal, createEffect } from "solid-js";
import { position } from "common";
import { DropdownContext, DropdownProvider } from "common";
import { DropdownTrigger } from "./fragments/DropdownTrigger";
import { DropdownContent } from "./fragments/DropdownContent";

export class DropdownMenuProps {
    open?: Signal<boolean>
    class?: string
    placement?: position.Placement
}

export default function Dropdown(props: ParentProps<DropdownMenuProps>) {
    const dropdownContext = new DropdownContext(props.open);

    createEffect(() => {
        dropdownContext.setPlacement(props.placement ?? 'bottom-start')
    })

    return (
        <DropdownProvider value={dropdownContext}>
            {props.children}
        </DropdownProvider>
    )
}

Dropdown.defaultProps = new DropdownMenuProps();
Dropdown.Trigger = DropdownTrigger;
Dropdown.Content = DropdownContent;